<template>
    <v-row :class="`ma-n1 datetime-picker-${className}`" style="position: relative" align="end">
        <v-col class="pa-1">
            <v-menu max-width="360" v-model="showsDate" :close-on-content-click="false" :attach="`.datetime-picker-${className}`" bottom nudge-bottom="56">
                <template #activator="{ attrs, on }">
                    <v-text-field :label="`${label}(날짜)`" type="date" max="2999-12-31" :value="date" v-bind="{ ...attrs, ...attrs_input }" v-on="on" readonly />
                </template>
                <v-date-picker v-model="date" @change="showsDate = false" />
            </v-menu>
        </v-col>
        <v-col class="pa-1" v-if="!hideTime">
            <v-menu max-width="360" v-model="showsTime" :close-on-content-click="false" :attach="`.datetime-picker-${className}`" bottom nudge-bottom="56">
                <template #activator="{ attrs, on }">
                    <v-text-field :label="`${label}(시간)`" :value="time" v-bind="{ ...attrs, ...attrs_input }" v-on="on" readonly />
                </template>
                <v-time-picker v-model="time" use-seconds @click:seconds="showsTime = false" />
            </v-menu>
        </v-col>
        <v-col class="pa-1" cols="auto" v-if="clearable">
            <v-btn icon tile class="transparent" @click="undo">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

export default {
    props: {
        value: { type: [Date, Number, String], default: null },
        label: String,
        hideTime: { type: Boolean, default: false },
        clearable: { type: Boolean, default: false },
        attrs_input: { type: Object, default: () => ({}) },
    },
    data: () => ({
        showsDate: false,
        showsTime: false,
        date: null,
        time: null,

        className: Math.random().toString().slice(2),
    }),
    computed: {
        datetime() {
            return dayjs.tz(`${this.date} ${this.time}`).toISOString();
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        date() {
            this.time ? this.$emit("input", this.datetime) : this.$emit("input", this.date);
        },
        time() {
            this.$emit("input", this.date && this.time ? this.datetime : null);
        },
        value() {
            this.init();
        },
    },
    methods: {
        init() {
            if (this.value) {
                this.date = dayjs(this.value).format("YYYY-MM-DD");
                this.time = dayjs(this.value).format("HH:mm:ss");
            } else {
                this.date = null;
                this.time = null;
            }
        },
        undo() {
            this.date = null;
            this.time = null;
        },
    },
};
</script>

<style lang="scss" scoped></style>
